import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IAuditoria, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { IFiltroTabla } from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { DetallesAuditoriaDialogComponent } from '../detalles-auditoria-dialog/detalles-auditoria-dialog.component';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';

@Component({
  selector: 'app-listado-auditorias',
  templateUrl: './listado-auditorias.component.html',
  styleUrl: './listado-auditorias.component.scss',
  standalone: false,
})
export class ListadoAuditoriasComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private formularios = inject(FormularioDialogService);

  public name = 'ListadoAuditoriasComponent';
  public auditorias?: IAuditoria[];
  public totalCount = 0;
  public columnas?: IColumnas<IAuditoria>[];
  public auditorias$?: Subscription;

  // FILTROS
  public fechaFiltro: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Fecha',
    tipo: 'dateRange',
  };

  public entidadFiltro: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'entidad',
    },
    label: 'Entidad',
    tipo: 'input',
  };

  public accionFiltro: IFiltroTabla = {
    elementos: [
      { label: 'Crear', value: 'Crear' },
      { label: 'Editar', value: 'Editar' },
      { label: 'Eliminar', value: 'Eliminar' },
      { label: 'Ver', value: 'Ver' },
    ],
    filter: {
      field: 'accion',
    },
    label: 'Acción',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };

  public usuarioFiltro: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idUsuario',
    },
    label: 'Usuario',
    selectLabel: 'usuario',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'usuarios',
    searchOn: ['usuario', 'datosPersonales.nombre'],
  };

  public filtros: IFiltroTabla[] = [
    this.fechaFiltro,
    this.entidadFiltro,
    this.accionFiltro,
    this.usuarioFiltro,
  ];

  public query: IQueryParam = {
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public listar(): void {
    this.auditorias$?.unsubscribe();
    this.auditorias$ = this.lista2.auditorias(this.query).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.auditorias = data.datos;
    });
  }

  public verDetalles(auditoria: IAuditoria): void {
    this.formularios.abrir(DetallesAuditoriaDialogComponent, {
      tamano: 'mediano',
      data: auditoria,
      cerrarAfuera: true,
    });
  }

  private setColumnas(): void {
    this.columnas = [
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
        },
      },
      {
        header: {
          label: 'Usuario',
        },
        row: {
          field: 'nombreUsuario',
          noData: 'Sin usuario',
        },
      },
      {
        header: {
          label: 'Entidad',
        },
        row: {
          field: 'entidad',
          noData: 'Sin entidad',
        },
      },
      {
        header: {
          label: 'Acción',
        },
        row: {
          // La acción con su ícono de la guía (sin colores propios)
          html(dato) {
            if (!dato.accion) return '';
            const iconos: Record<string, string> = {
              Crear: 'add',
              Editar: 'edit',
              Eliminar: 'delete',
              Ver: 'search',
            };
            const icono = iconos[dato.accion];
            return `<div class="tabla-linea">${
              icono
                ? `<span class="material-symbols-outlined">${icono}</span>`
                : ''
            }<span>${escaparHtml(dato.accion)}</span></div>`;
          },
          noData: 'Sin acción',
        },
      },
      {
        header: {
          label: 'Campos modificados',
        },
        row: {
          html(dato) {
            if (!dato.camposModificados?.length) return '';
            return `<span>${dato.camposModificados
              .map((c) => escaparHtml(c))
              .join(', ')}</span>`;
          },
          noData: 'Sin campos modificados',
        },
      },
      {
        header: {
          label: 'Acciones',
        },
        row: {
          acciones: [
            {
              tipo: 'material',
              color: 'primary',
              icon: 'visibility',
              tooltip: 'Ver detalle',
              click: (dato) => this.verDetalles(dato),
            },
          ],
        },
      },
    ];
  }

  async ngOnInit(): Promise<void> {
    this.setColumnas();
    this.listar();
  }

  ngOnDestroy(): void {
    this.auditorias$?.unsubscribe();
  }
}
